import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { supportData } from '../data/storeData';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Support() {
  const [activeTab, setActiveTab] = useState('faq');
  const [openFaq, setOpenFaq] = useState(null);

  const tabs = [
    { id: 'faq', label: 'FAQ', icon: FiIcons.FiHelpCircle },
    { id: 'care', label: 'Care Guide', icon: FiIcons.FiTool },
    { id: 'policies', label: 'Shipping & Returns', icon: FiIcons.FiTruck }
  ];

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="min-h-screen bg-cream py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="font-serif text-4xl text-navy mb-4">Workshop Support</h1>
          <p className="font-sans text-saddle">Everything you need to know about our goods and services.</p>
        </div>

        <div className="flex flex-col md:flex-row gap-8">
          {/* Sidebar Nav */}
          <div className="md:w-1/3">
            <div className="bg-white border border-brass/20 p-2 flex flex-col gap-2">
              {tabs.map(tab => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-3 w-full p-4 text-left font-sans text-sm tracking-widest uppercase transition-colors ${
                    activeTab === tab.id ? 'bg-navy text-cream' : 'bg-transparent text-navy hover:bg-creamDark'
                  }`}
                >
                  <SafeIcon icon={tab.icon} className="w-5 h-5 pointer-events-none" />
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* Content Area */}
          <div className="md:w-2/3 bg-white p-8 border border-brass/20 min-h-[400px]">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2 }}
              >
                {activeTab === 'faq' && (
                  <div className="space-y-4">
                    <h2 className="font-serif text-2xl text-navy mb-6 border-b border-brass/20 pb-4">Frequently Asked Questions</h2>
                    {supportData.faq.map((item, idx) => (
                      <div key={idx} className="border border-creamDark">
                        <button 
                          onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                          className="w-full p-4 text-left flex justify-between items-center font-sans font-medium text-navy hover:bg-cream"
                        >
                          {item.q}
                          <SafeIcon icon={openFaq === idx ? FiIcons.FiMinus : FiIcons.FiPlus} />
                        </button>
                        {openFaq === idx && (
                          <div className="p-4 pt-0 text-navy/70 font-sans text-sm leading-relaxed bg-cream/30">
                            {item.a}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'care' && (
                  <div className="space-y-8">
                    <h2 className="font-serif text-2xl text-navy mb-6 border-b border-brass/20 pb-4">Leather Care Guide</h2>
                    {supportData.care.map((item, idx) => (
                      <div key={idx}>
                        <h3 className="font-serif text-lg text-saddle mb-2">{item.title}</h3>
                        <p className="font-sans text-sm text-navy/80 leading-relaxed">{item.text}</p>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'policies' && (
                  <div className="space-y-8">
                    <h2 className="font-serif text-2xl text-navy mb-6 border-b border-brass/20 pb-4">Store Policies</h2>
                    {supportData.policies.map((item, idx) => (
                      <div key={idx}>
                        <h3 className="font-sans text-sm tracking-widest uppercase text-navy font-semibold mb-3">{item.title}</h3>
                        <p className="font-sans text-sm text-navy/80 leading-relaxed bg-creamDark p-4 border-l-2 border-saddle">
                          {item.text}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </motion.div>
  );
}